import { UpdateMagazineCategoryDto } from "../entity/magazineCategory/dto/update-category-dto";
import { magazineCategoryService } from "../entity/magazineCategory/MagazineCategoryService";

export const updateMagazineCategoryUseCase = async (body: UpdateMagazineCategoryDto) => {
    try {
        const { id, ...rest } = body;

        // Filter out undefined and null values
        const filteredBody = Object.fromEntries(
            Object.entries(rest).filter(([_, value]) => value !== undefined && value !== null)
        );

        const response = await magazineCategoryService.update(id, filteredBody);
        return response;
    } catch (error) {
        console.warn('updateMagazineCategoryUseCase: ', error);
        return { isError: true, data: null, message: '' };
    }
}
